document.addEventListener("DOMContentLoaded", function() {
  // Target the form + input
  const searchForm = document.querySelector('.header-search-form');
  const searchInput = document.querySelector('.header-search-input');

  if (searchForm) {
    searchForm.removeAttribute('data-predictive-search-form');
    searchForm.removeAttribute('aria-owns'); // Shopify predictive hook
  }

  if (searchInput) {
    searchInput.removeAttribute('data-predictive-search-input');
    searchInput.removeAttribute('aria-controls');
    searchInput.removeAttribute('aria-expanded');
    searchInput.setAttribute('autocomplete', 'off');
    searchInput.setAttribute('role', 'searchbox');

    // Replace input to kill all event listeners Shopify may have added
    const clone = searchInput.cloneNode(true);
    searchInput.parentNode.replaceChild(clone, searchInput);
  }

  // Also remove predictive-search element completely if injected
  const predictive = document.querySelector('predictive-search');
  if (predictive) predictive.remove();
});
// Custom JavaScript for Francis Wain Jewellers
// This script initializes the video iframe and sets the SKU value in a popup input field
  
$( document ).ready(function() {
  
  let iframe = $("#iframevideo").attr('data-src');
  
  if(typeof iframe !== 'undefined'){
    const waypoints = [
      {
        id: 'iframevideo',
        handler(direction) { 
          let newsrc = $("#iframevideo").attr('data-src');
          $("#iframevideo").attr('src', newsrc );
          $("#iframevideo").removeAttr('data-src');
        }
      }
    ];

    waypoints.forEach(({ id, handler }) => (
      new Waypoint({
        element: document.getElementById(id),
        handler,
        offset: 20 // añade un margen superior opcional
      })
    ));
  }

   // Find the element with the class "variant-sku"
  const skuElement = $(".variant-sku");
  
  // Check if the element exists
  if (skuElement.length > 0) {
    // Read the SKU value
    const skuValue = skuElement.text();
    setTimeout(function() {
       $("#popup1 input#hidden-1").val(skuValue);
    }, 3000); // 2000 milliseconds = 2 seconds
  }  
  
});
